// Loads third-party marketing and analytics scripts after consent.
// Kept out of index.html so the CSP does not need 'unsafe-inline' for scripts.
const _LOADED = {};
let _INIT = false;
// Configuration constants
const TRUSTARC_CONFIG = {
  POLLING_INTERVAL: 100, // ms - reduced from 50ms for better performance
  MAX_POLLING_ATTEMPTS: 100, // 10 seconds total
  RELOAD_DELAY: 250 // ms - increased for better reliability
};

// --- VENDOR LOADER FUNCTIONS ---------------------------------------------

function getMarketingConfig(attribute) {
  const div = document.getElementById("marketing-config");
  return div ? div.getAttribute(attribute) : null;
}

function loadDrift() {
  if (_LOADED.drift) return;
  const div = document.getElementById("marketing-config");
  const id = div ? div.getAttribute("data-drift-id") : null;
  if (!id) return;

  !(function () {
    const t = (window.driftt = window.drift = window.driftt || []);
    if (!t.init) {
      if (t.invoked) return;
      ((t.invoked = !0),
        (t.methods = [
          "identify",
          "config",
          "track",
          "reset",
          "debug",
          "show",
          "ping",
          "page",
          "hide",
          "off",
          "on"
        ]),
        (t.factory = function (e) {
          return function () {
            const n = Array.prototype.slice.call(arguments);
            return (n.unshift(e), t.push(n), t);
          };
        }),
        t.methods.forEach(function (e) {
          t[e] = t.factory(e);
        }),
        (t.load = function (t) {
          const e = 3e5,
            n = Math.ceil(new Date() / e) * e,
            o = document.createElement("script");
          ((o.type = "text/javascript"),
            (o.async = !0),
            (o.crossorigin = "anonymous"),
            (o.src = "https://js.driftt.com/include/" + n + "/" + t + ".js"));
          const i = document.getElementsByTagName("script")[0];
          i.parentNode.insertBefore(o, i);
        }));
    }
  })();
  window.drift.SNIPPET_VERSION = "0.3.1";
  window.drift.load(id);
  _LOADED.drift = true;
}

function loadPendo() {
  if (_LOADED.pendo) return;
  const div = document.getElementById("marketing-config");
  if (!div) return;

  let id = div.getAttribute("data-pendo-id");
  if (window.location.origin === div.getAttribute("data-auth-url")) {
    id = div.getAttribute("data-pendo-auth-id");
  }
  if (!id) return;

  (function (apiKey) {
    (function (p, e, n, d, o) {
      let v, w, x, y, z;
      o = p[d] = p[d] || {};
      o._q = o._q || [];
      v = ["initialize", "identify", "updateOptions", "pageLoad", "track"];
      for (w = 0, x = v.length; w < x; ++w)
        (function (m) {
          o[m] =
            o[m] ||
            function () {
              o._q[m === v[0] ? "unshift" : "push"](
                [m].concat([].slice.call(arguments, 0))
              );
            };
        })(v[w]);
      y = e.createElement(n);
      y.async = !0;
      y.src =
        "https://content.engage.upsun.com/agent/static/" + apiKey + "/pendo.js";
      z = e.getElementsByTagName(n)[0];
      z.parentNode.insertBefore(y, z);
    })(window, document, "script", "pendo");
  })(id);
  _LOADED.pendo = true;
}

function loadAdvertisingTags() {
  loadGoogleAds();
  loadLinkedInInsight();
  loadRedditPixel();
}

function loadGoogleAds() {
  if (_LOADED.googleAds) return;
  const id = getMarketingConfig("data-google-ads-id");
  if (!id) return;

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.googletagmanager.com/gtag/js?id=" + id;
  document.body.appendChild(script);

  // The script is served from googletagmanager.com but loads Google Ads
  // directly (gtag), not a GTM container.
  window.dataLayer = window.dataLayer || [];
  window.gtag = function () {
    window.dataLayer.push(arguments);
  };
  window.gtag("js", new Date());
  window.gtag("config", id);
  _LOADED.googleAds = true;
}

function loadLinkedInInsight() {
  if (_LOADED.linkedIn) return;
  const id = getMarketingConfig("data-linkedin-partner-id");
  if (!id) return;

  window._linkedin_partner_id = id;
  window._linkedin_data_partner_ids = window._linkedin_data_partner_ids || [];
  window._linkedin_data_partner_ids.push(id);
  window.lintrk =
    window.lintrk ||
    function (a, b) {
      window.lintrk.q.push([a, b]);
    };
  window.lintrk.q = window.lintrk.q || [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://snap.licdn.com/li.lms-analytics/insight.min.js";
  document.body.appendChild(script);
  _LOADED.linkedIn = true;
}

function loadRedditPixel() {
  if (_LOADED.reddit) return;
  const id = getMarketingConfig("data-reddit-pixel-id");
  if (!id) return;

  window.rdt =
    window.rdt ||
    function () {
      window.rdt.sendEvent
        ? window.rdt.sendEvent.apply(window.rdt, arguments)
        : window.rdt.callQueue.push(arguments);
    };
  window.rdt.callQueue = window.rdt.callQueue || [];

  const script = document.createElement("script");
  script.async = true;
  script.src = "https://www.redditstatic.com/ads/pixel.js";
  document.body.appendChild(script);

  window.rdt("init", id);
  window.rdt("track", "PageVisit");
  _LOADED.reddit = true;
}

// --- CONSENT ROUTER ------------------------------------------------------

/**
 * Receives approved categories and triggers the appropriate loaders.
 * @param {string} category - The Category ID or Name from TrustArc.
 */
function onConsentGranted(category) {
  switch (String(category).toLowerCase()) {
    case "2":
    case "functional":
      loadDrift();
      break;

    case "3":
    case "advertising":
      loadAdvertisingTags();
      break;

    case "4":
    case "analytics":
      loadPendo();
      break;
  }
}

// --- TRUSTARC INTEGRATION ------------------------------------------------

function initTrustArc() {
  if (_INIT || !window.PrivacyManagerAPI || !window.truste || !window.truste.eu)
    return;
  _INIT = true;

  // 1. Hook into TrustArc Close Event to handle consent revocation (Auto-Reload)
  const oldPrefClose = window.truste.eu.prefclose;
  const startCookie = window.truste.eu.bindMap.prefCookie;

  window.truste.eu.prefclose = function () {
    oldPrefClose();
    const endCookie = window.truste.eu.bindMap.prefCookie;
    // If consent preferences changed, reload to ensure revoked scripts are unloaded
    if (startCookie !== endCookie) {
      setTimeout(function () {
        window.location.reload();
      }, TRUSTARC_CONFIG.RELOAD_DELAY);
    }
  };

  // 2. Listen for "Approved" messages from the API
  window.addEventListener(
    "message",
    function (e) {
      try {
        const json = JSON.parse(e.data);
        const api = json.PrivacyManagerAPI;
        if (api && api.action === "getConsent" && api.consent === "approved") {
          onConsentGranted(api.type);
        }
      } catch {
        // Silently ignore malformed messages
      }
    },
    false
  );

  // 3. Query current status for all categories
  // We loop through all potential categories to check current status
  const baseReq = {
    PrivacyManagerAPI: {
      self: window.location.hostname,
      action: "getConsent",
      timestamp: new Date().getTime()
    }
  };

  ["functional", "advertising", "4"].forEach(function (type) {
    const req = JSON.parse(JSON.stringify(baseReq));
    req.PrivacyManagerAPI.type = type;
    window.top.postMessage(JSON.stringify(req), "*");
  });
}

// --- MAIN INITIALIZATION -------------------------------------------------

document.addEventListener("DOMContentLoaded", function () {
  // Localhost check
  function isLocalhost() {
    return (
      window.location.hostname === "localhost" ||
      window.location.hostname === "127.0.0.1" ||
      window.location.hostname.startsWith("192.168.") ||
      window.location.hostname.indexOf(".local") !== -1
    );
  }

  if (isLocalhost()) return;

  const configDiv = document.getElementById("marketing-config");
  if (!configDiv) return;

  // 1. Load TrustArc (Category 1 - Required)
  const cookielawId = configDiv.getAttribute("data-cookielaw-id");
  if (cookielawId) {
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src =
      "https://consent.trustarc.com/v2/notice/" + cookielawId + "?pcookie";
    script.setAttribute("async", "async");
    script.setAttribute("crossorigin", "");
    document.body.appendChild(script);

    // Poll for API existence with timeout
    let attempts = 0;
    const interval = setInterval(function () {
      attempts++;
      if (window.PrivacyManagerAPI) {
        initTrustArc();
        clearInterval(interval);
      } else if (attempts >= TRUSTARC_CONFIG.MAX_POLLING_ATTEMPTS) {
        clearInterval(interval);
        // oxlint-disable-next-line no-console
        console.warn("TrustArc API not available after polling timeout");
      }
    }, TRUSTARC_CONFIG.POLLING_INTERVAL);
  } else {
    // When TrustArc is not configured, load analytics directly
    // This allows Pendo to work in staging/design environments
    loadPendo();
    loadDrift();
  }
});
